<div class="pdf-viewer-wrapper">
    <div #pdfViewer class="pdf-viewer-container" (scroll)="handleScroll($event)">
    <div #pdfContainer class="pdf-pages-container">
    </div>
    <div *ngIf="isLoading" class="loading-indicator">
    <div class="spinner"></div>
    </div>
    </div>
    </div>